export interface Video {
  productName: string
  productSku: string
  url: string
  thumbnail: string
}

export const videoList: Video[] = [
  {
    productName: 'Unboxing Mães',
    productSku: '87408',
    url: 'https://youtu.be/7UYTQzA_WPE',
    thumbnail: 'https://img.youtube.com/vi/7UYTQzA_WPE/maxresdefault.jpg',
  },
  {
    productName: 'Cuide-se bem: Doçura na Pessegura',
    productSku: '57043',
    url: 'https://youtube.com/shorts/iv8rej7M6fE',
    thumbnail: 'https://img.youtube.com/vi/iv8rej7M6fE/maxresdefault.jpg',
  },
  {
    productName: 'Shampoo Suave Boti Baby',
    productSku: '52019',
    url: 'https://youtube.com/shorts/L7D3gsb2Uas',
    thumbnail: 'https://img.youtube.com/vi/L7D3gsb2Uas/maxresdefault.jpg',
  },
  {
    productName: 'Gel Hidratante Refrescante Facial Cuide-se Bem Feira Maçã Verde',
    productSku: '54804',
    url: 'https://youtube.com/shorts/svXzCvpHdNk',
    thumbnail: 'https://img.youtube.com/vi/svXzCvpHdNk/maxresdefault.jpg',
  },
  {
    productName: 'Gel de Limpeza Facial Cuide-se Bem Feira Tangerina',
    productSku: '54802',
    url: 'https://youtube.com/shorts/mBtT4O2qZ_4',
    thumbnail: 'https://img.youtube.com/vi/mBtT4O2qZ_4/maxresdefault.jpg',
  },
  {
    productName: 'Máscara Facial Noturna Cuide-se Bem Melancia',
    productSku: '54805',
    url: 'https://youtube.com/shorts/Iea0YYFwCFg',
    thumbnail: 'https://img.youtube.com/vi/Iea0YYFwCFg/maxresdefault.jpg',
  },
  {
    productName: 'Desodorante Colônia Clash',
    productSku: '50677',
    url: 'https://youtube.com/shorts/K4MNyomB8-s',
    thumbnail: 'https://img.youtube.com/vi/K4MNyomB8-s/sddefault.jpg',
  },
]
